import { createSlice } from "@reduxjs/toolkit";

let local_store = window.localStorage.getItem("persist:root");
var global_lenguage = local_store ? (local_store.indexOf("lenguaje_eng") !== -1 ? "lenguaje_eng" : "lenguaje_ptl") : "lenguaje_ptl";

const initialState = {
    language: global_lenguage,
    globalLoader: false,
    questionMenssage: {
        shower: false,
        type_question: 0, //1-OK, 2- Questions, 3-Error
        title: "",
        description: "",
        funcion: null,
        cancelButton: "Cancel",
        okButton: "Ok",
    },
    dinamicMessage: {
        shower: false,
        type_question: 0, //1-OK, 2- Warning, 3-Error
        title: "",
        description: "",
    },
    indicators: {
        listKeysIndicators: [],
        listAllIndicators: [],
    },
    editSingleBoard: null,
    editDashBoard: null,
};

const globalSlice = createSlice({
    name: "globalStore",
    initialState,
    reducers: {
        switchLanguage(state, action) {
            state.language = action.payload;
        },
        showGlobalLoader(state, action) {
            state.globalLoader = action.payload;
        },
        showQuestionMenssage(state, action) {
            state.questionMenssage.shower = action.payload.shower;
            state.questionMenssage.type_question = action.payload.type_question;
            state.questionMenssage.title = action.payload.title;
            state.questionMenssage.description = action.payload.description;
            state.questionMenssage.funcion = action.payload.funcion;
            state.questionMenssage.cancelButton = action.payload.cancelButton;
            state.questionMenssage.okButton = action.payload.okButton;
        },
        showDinamicMessage(state, action) {
            state.dinamicMessage.shower = action.payload.shower;
            state.dinamicMessage.type_question = action.payload.type_question;
            state.dinamicMessage.title = action.payload.title;
            state.dinamicMessage.description = action.payload.description;
        },
        closeQuestionMenssage(state, action) {
            state.questionMenssage.shower = action.payload;
        },
        closeDinamicMessage(state, action) {
            state.dinamicMessage.shower = action.payload;
        },
        updateListKeysIndicators(state, action) {
            state.indicators.listKeysIndicators = action.payload;
        },
        updateListAllIndicators(state, action) {
            state.indicators.listAllIndicators = action.payload;
        },
        updateEditSingleBoard(state, action) {
            state.editSingleBoard = action.payload;
        },
        updateEditDashBoard(state, action) {
            state.editDashBoard = action.payload;
        },
    },
});

export const globalSliceActions = globalSlice.actions;
export default globalSlice.reducer;
